import { RuleDefinition } from "../type-validator";
import { custom } from "./custom";

export const nonEmptyString: RuleDefinition = custom((value) => [
  typeof value === "string" && value.length > 0,
  "a non-empty string",
]);
